let services = document.querySelectorAll('section.services')

if(services.length) {
    for(let section of services) {
        let items = section.querySelectorAll('.service-item')
        let itemsWrapper = section.querySelector('.services-grid')
        let images = section.querySelectorAll('.image')

        if(images.length) {
            for(let item of items) {
                item.addEventListener('mouseenter', () => {
                    let index = Number(item.dataset.index)
    
                    for(let image of images) {
                        image.classList.remove('active')
                    }
    
                    images[index].classList.add('active')
                })
            }

            itemsWrapper.addEventListener('mouseleave', () => {
                for(let image of images) {
                    image.classList.remove('active')
                }
    
                images[0].classList.add('active')
            })
        }

        let mobileItems = section.querySelectorAll('.mobile-services .service')

        if(mobileItems.length) {
            for(let item of mobileItems) {
                let header = item.querySelector('.service-header')

                header.addEventListener('click', () => {
                    for(let mobileItem of mobileItems) {
                        if(!mobileItem.isEqualNode(item)) {
                            mobileItem.classList.remove('active')
                        }
                    }

                    item.classList.toggle('active')
                })
            }
        }
    }
}